import { toast } from 'sonner';

/**
 * Shows a notification for unsupported features in demo mode
 * @param action - The action that was attempted (e.g. "Create Organization", "Invite Members")
 * @param isDemo - Whether we're in demo mode
 */
export const notifyFeature = (action: string, isDemo: boolean = false) => {
  if (isDemo) {
    toast.info(`Demo Mode - Feature Unsupported`, {
      description: `${action} is not available in demo mode`
    });
  } else {
    toast.info(`${action} - Coming Soon!`);
  }
};

/**
 * Shows a notification for demo actions (things that would work but are simulated)
 * @param action - The action description (e.g. "Delete role", "Update member")
 * @param isDemo - Whether we're in demo mode
 */
export const notifyDemoAction = (action: string, isDemo: boolean = true) => {
  if (isDemo) {
    toast.success(`Demo Mode - ${action}`, {
      description: 'Action simulated successfully'
    });
  } else {
    toast.info(`${action} - Coming Soon!`);
  }
};